import { combineReducers } from 'redux';

import { pending, fulfilled, rejected } from '../utils/helpers';
import { types } from '../actions/exportDialog';
import { ExportFileFormat, ExportSource, ExportTimeSource } from '../constants';

export const dialogField = (setterAction, initialState) => (
  state = initialState,
  { type, payload },
) => {
  switch (type) {
    case types.OPEN_EXPORT_DIALOG:
      return initialState;

    case setterAction:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  includeDataset: dialogField(types.SET_EXPORT_INCLUDE_DATASET, true),

  fileFormat: dialogField(types.SET_EXPORT_FILE_FORMAT, ExportFileFormat.CSV),

  exportSource: (state = ExportSource.ALL, { type, payload }) => {
    switch (type) {
      case types.OPEN_EXPORT_DIALOG:
        if (payload === '/map') {
          return ExportSource.ALL;
        } else {
          return ExportSource.SELECTED;
        }

      case types.SET_EXPORT_SOURCE:
        return payload;

      default:
        return state;
    }
  },

  timeSource: dialogField(
    types.SET_EXPORT_TIME_SOURCE,
    ExportTimeSource.SELECTED,
  ),

  includeMetadata: dialogField(types.SET_EXPORT_INCLUDE_METADATA, false),

  agreedToTerms: dialogField(types.SET_AGREED_TO_TERMS, false),

  opened: (state = false, { type, payload }) => {
    switch (type) {
      case types.OPEN_EXPORT_DIALOG:
        return true;

      case fulfilled(types.EXPORT_DOWNLOAD):
      case types.CLOSE_EXPORT_DIALOG:
        return false;

      default:
        return state;
    }
  },

  downloadsPending: (state = false, { type, payload }) => {
    switch (type) {
      case pending(types.EXPORT_DOWNLOAD):
        return true;

      case rejected(types.EXPORT_DOWNLOAD):
      case fulfilled(types.EXPORT_DOWNLOAD):
        return false;

      default:
        return state;
    }
  },

  downloadsFailed: (state = false, { type, payload }) => {
    switch (type) {
      case rejected(types.EXPORT_DOWNLOAD):
        return true;

      case types.OPEN_EXPORT_DIALOG:
        return false;

      case types.SET_EXPORT_INCLUDE_DATASET:
      case types.SET_EXPORT_FILE_FORMAT:
      case types.SET_EXPORT_SOURCE:
      case types.SET_EXPORT_TIME_SOURCE:
      case types.SET_EXPORT_INCLUDE_METADATA:
        return false;

      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./src/reducers/exportDialog.js